import styled from 'styled-components';

import { Text } from '@/components/Typography';

export const PlaceholderText = styled(Text)`
	color: #bfbfbf;
`;
